import React, { useRef, useState } from 'react';
import { Play, Pause } from 'lucide-react';

const ControlPanel = () => {
  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const togglePlay = () => {
    if (videoRef.current) {
      if (isPlaying) {
        videoRef.current.pause();
      } else {
        videoRef.current.play();
      }
      setIsPlaying(!isPlaying);
    }
  };

  return (
    <section className="py-20 px-6 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-4xl lg:text-5xl font-bold mb-4 text-gray-900">
            All-in-One Control Panel for Fleet Managers
          </h2>
          <p className="text-gray-600 text-lg max-w-3xl mx-auto">
            Monitor jobs, assign routes, communicate with drivers, and analyze efficiency - all from one place.
          </p>
        </div>
        
        <div className="relative rounded-3xl overflow-hidden shadow-2xl group">
          <video 
            ref={videoRef}
            className="w-full h-auto"
            onClick={togglePlay}
            onEnded={() => setIsPlaying(false)}
          >
            <source src="https://customer-assets.emergentagent.com/job_page-blueprint-2/artifacts/ahukg9qi_laptop.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          
          {!isPlaying && (
            <div 
              className="absolute inset-0 bg-black/30 flex items-center justify-center cursor-pointer group-hover:bg-black/40 transition-all duration-300"
              onClick={togglePlay}
            >
              <button className="bg-white/90 hover:bg-white text-gray-900 w-20 h-20 rounded-full flex items-center justify-center shadow-2xl transform group-hover:scale-110 transition-all duration-300">
                <Play className="w-10 h-10 ml-2" fill="currentColor" />
              </button>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default ControlPanel;
